import { EOfferType } from './jsonQuery';
import { capitalize } from './string';

const OfferTypeNames: { [key: number]: string } = {
  [EOfferType.House]: 'дом, дачу',
  [EOfferType.HousePart]: 'часть дома',
  [EOfferType.Townhouse]: 'таунхаус',
  [EOfferType.Land]: 'участок',
};

export function getOfferTypeLabel(offerType: EOfferType): string | null {
  if (offerType in OfferTypeNames) {
    return capitalize(OfferTypeNames[offerType]);
  }

  const offerTypeName = Object.keys(OfferTypeNames)
    .map<string | null>(type => ((Number(type) & offerType) !== 0 ? OfferTypeNames[Number(type)] : null))
    .filter(Boolean)
    .join(', ');

  const label = offerTypeName || Object.values(OfferTypeNames).join(', ');

  return capitalize(label);
}
